'use client';

import { ErrorContent } from '@ordering/components/ErrorContent';
import { useReportError } from '@ordering/hooks/useReportError';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useReportError(error, 'global-error-boundary');

  return (
    <html>
      <body>
        <ErrorContent title="Something went wrong" description="Please try refreshing the page." />
      </body>
    </html>
  );
}
